import { render, staticRenderFns } from "./ElectricMeter.vue?vue&type=template&id=36c5385e"
import script from "./ElectricMeter.vue?vue&type=script&lang=js"
export * from "./ElectricMeter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports